import { SpotPill } from '@enterprise/spot';
import { GridRenderCellParams } from '@enterprise/material-data-grid';
import styles from './ImportPage.module.scss';
import { ImportGridRow } from './hooks';

const getStatusConfig = (value?: string) => {
    if (!value) {
        return { type: 'warning' as const, icon: 'alert-notification', message: 'Unknown Status' };
    }

    const message = value.substring(value.indexOf(': ') + 2);

    if (value.includes('WARNING')) {
        return { type: 'warning' as const, icon: 'alert-notification', message };
    }

    if (value.includes('ERROR')) {
        return { type: 'negative' as const, icon: 'alert-notification', message };
    }

    if (value.includes('SUCCESS')) {
        return { type: 'positive' as const, icon: 'checkmark', message };
    }

    return { type: 'warning' as const, icon: 'alert-notification', message: 'Unknown Status' };
};

export function ImportStatusCellRenderer({ value }: GridRenderCellParams<ImportGridRow, string>) {
    const { type, icon, message } = getStatusConfig(value);

    return (
        <SpotPill type={type} icon={icon} className={styles.pill}>
            <span data-automation-id="import-status-pill-text" className="spot-pill__icon-label">
                {message}
            </span>
        </SpotPill>
    );
}
